var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"email-confirm"}},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.confirmEmail.apply(null, arguments)}}},[_vm._v("\n      Confirm This Email\n\n      "),(_vm.loading)?_c('spinner',{attrs:{"size":"small"}}):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e6f78ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmailConfirm.vue
// module id = 1247
// module chunks = 1